export var LinkTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return ({
                display: "inline-flex",
                alignItems: "center",
                gap: theme.spacing(1),
                '&[disabled]': {
                    color: theme.palette.text.primary,
                    opacity: 0.48,
                    pointerEvents: "none",
                },
            });
        },
    },
}); };
export default LinkTheme;
//# sourceMappingURL=theme.js.map